module.exports = __WEBPACK_EXTERNAL_MODULE_279__;


//////////////////
// WEBPACK FOOTER
// external "comsMobx"
// module id = 279
// module chunks = 0